<template>
  <a :class="[iconOrientationClass, {'active': isActive}]" v-on:click="click" data-balloon-length="medium" :data-balloon="tooltip ? $t(tooltip) : undefined" :data-balloon-pos="tooltipOrientation">
    <i v-if="iconClass" :class="iconClass"></i>
    <span>{{ label }}</span>
    <i v-if="tooltip" class="fa fa-info-circle"></i>
    <i v-if="hasChildren" class="fa fa-chevron-right" aria-hidden="true"></i>
  </a>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    index: {},
    icon: {
      type: String
    },
    label: {
      type: String
    },
    isActive: {
      type: Boolean
    },
    hasChildren: {
      type: Boolean
    },
    iconOrientation: {
      type: String,
      default: 'left'
    },
    tooltip: {
      type: String
    },
    tooltipOrientation: {
      type: String,
      default: 'right' // up, down, left or right
    }
  },
  computed: {
    iconClass() {
      if (typeof this.icon == 'undefined' && this.hasChildren)
        return null;

      return 'icon fa-' + (typeof this.icon == 'undefined' ? (this.isActive ? 'check-circle fas' : 'circle far') :  + this.icon);
    },
    iconOrientationClass() {
      if (typeof this.icon == 'undefined' && this.hasChildren)
        return null;

      return typeof this.iconOrientation == 'undefined' && this.iconOrientation == 'right' ? 'icon-right' : 'icon-left';
    }
  },
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>
